import { AdditionalDetailsFormForFunctioanry } from '../../../components/AdditionalDetailsFormForFunctionary';
import { useApplicantAdditionalDetailsPage } from './useApplicantAdditionalDetailsPage';

export const ApplicantAdditionalCollectionPageContainer = () => {
	const { onCancelClick, application } = useApplicantAdditionalDetailsPage();

	return (
		<div className="flex flex-col h-full min-h-0 bg-bground-blue">
			<AdditionalDetailsFormForFunctioanry
				application={application}
				onCancelClick={onCancelClick}
			/>
		</div>
	);
};
